/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dx-overlay-content{background-color:#2a2a2ad9!important;max-width:750px!important;max-height:200px!important}  .dx-overlay-shader{background-color:transparent!important}.popover-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;text-align:center;justify-content:space-around}"];
export { styles as styles };
